import * as react from "react";
import * as reactDOM from "react-dom";
export class Portal extends react.Component {
    render() {
        return reactDOM.createPortal(this.props.children, this.props.globalState.hostElement);
    }
}
//# sourceMappingURL=portal.js.map